// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { ORDER_PROCESSING_ORDERS_URL } from './order.constants';
import { CreateOrderParam, OrderDetails, OrderDetailsWithPaymentIntentInfo } from './order.interfaces';
import {
  AxiosHookResponse,
  useAxiosGetRequest,
  useAxiosPostRequest,
} from 'app-shared/lib/api/utils/axios-request.hooks';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { useSWRAxiosGetRequest } from 'app-shared/lib/api/utils/swr-axios-request.hooks';
import { SWRResponse } from 'swr';
import { PromotionCodeDetails } from '../promotion-code';

/**
 * Process order api hook
 */
export const useCreateOrder = (): AxiosHookResponse<CreateOrderParam, OrderDetailsWithPaymentIntentInfo> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}`;

  return useAxiosPostRequest(url);
};

/**
 * Get order api hook
 */
export const useGetOrder = (id: number): SWRResponse<OrderDetails, Error> => {
  const urlOptional = id ? `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}/${id}` : null;

  return useSWRAxiosGetRequest(urlOptional, { revalidateOnFocus: false });
};

/**
 * Get order Api
 * @param id the id of the order
 * @returns the order details
 */
export const getOrder = (id: number): Promise<AxiosResponse<OrderDetails>> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}/${id}`;

  return axios.get(url);
};

/**
 * Get orders api hook
 */
export const useGetOrders = (): AxiosHookResponse<void, OrderDetails[]> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}`;

  return useAxiosGetRequest(url);
};

/**
 * Resend notification emails api
 */
export const resendNotificationEmails = (id: number): Promise<AxiosResponse<boolean>> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}/emails?id=${id}`;

  return axios.post(url);
};

/**
 * Order reject api
 */
export const checkIfCanOrderProduct = (id: number, quantity: number): Promise<AxiosResponse<boolean>> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}/products/check?id=${id}&quantity=${quantity}`;

  return axios.get(url);
};

/**
 * Check if can apply promotion code api
 */
export const useCheckIfCanApplyPromotionCode = (): AxiosHookResponse<void, PromotionCodeDetails> => {
  const url = `${API_COMMON_BASE_URL}/${ORDER_PROCESSING_ORDERS_URL}/promotion-code/check`;

  return useAxiosGetRequest(url);
};
